import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { SourceTablesPage } from "./-source-tables/source-tables.page";

export const Route = createFileRoute("/warehouse/source-tables/")({
  validateSearch: validateGridSearch,
  component: SourceTablesPage,
});
